"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var dotSpacing = 8;

function getProgressBarBGSize(count, now, dotSize) {
  var totalWidth = count * (dotSize + dotSpacing) - dotSpacing;
  var remaining = (count - now) * (dotSpacing + dotSize);
  return (1 - remaining / totalWidth) * 100;
}

var base = /*#__PURE__*/(0, _react.css)("display:inline-flex;&>*:not(:first-of-type){margin-left:", (0, _util.rem)(dotSpacing), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));

var connectionDot = function connectionDot(_ref) {
  var count = _ref.count,
      now = _ref.now,
      dotSize = _ref.dotSize,
      bgColor = _ref.bgColor,
      activeBgColor = _ref.activeBgColor;
  return /*#__PURE__*/(0, _react.css)("position:relative;&::before,&::after{content:'';position:absolute;border-radius:", (0, _util.rem)(200), ";left:0;top:0;}&::before{height:100%;width:", getProgressBarBGSize(count, now, dotSize), "%;background-color:", bgColor, ";transition:width 0.5s;z-index:-1;}&::after{height:", (0, _util.rem)(dotSize), ";width:", (0, _util.rem)(dotSize), ";background-color:", activeBgColor, ";transition:transform 0.5s;transform:translateX(", (0, _util.rem)((dotSpacing + dotSize) * (now - 1)), ");}" + (process.env.NODE_ENV === "production" ? "" : ";label:connectionDot;"));
};

var dotWrapper = /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(12), ";height:", (0, _util.rem)(12), ";display:flex;justify-content:center;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:dotWrapper;"));
var active = /*#__PURE__*/(0, _react.css)("transition:all 0.5s;width:", (0, _util.rem)(12), ";height:", (0, _util.rem)(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:active;"));
var styles = {
  base: base,
  connectionDot: connectionDot,
  dotWrapper: dotWrapper,
  active: active
};
exports.styles = styles;
//# sourceMappingURL=ProgressDots.styles.js.map